import { render, staticRenderFns } from "./OpenWaterAdminView.vue?vue&type=template&id=163e9756&"
import script from "./OpenWaterAdminView.vue?vue&type=script&lang=js&"
export * from "./OpenWaterAdminView.vue?vue&type=script&lang=js&"
import style0 from "./OpenWaterAdminView.vue?vue&type=style&index=0&id=163e9756&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports